import { useTheme } from '@mui/material/styles';
import { Tooltip, IconButton, Badge } from '@mui/material';
import { Psychology as ReflectIcon,
    RateReview as ReflectionIcon
 } from "@mui/icons-material";

const ReflectButton = ({ count, onReflectHandle, isOwnProfile }) => {
  const theme = useTheme();

  return (
<>      
      { isOwnProfile ? (
            <Tooltip title="Add Reflection">
              <IconButton 
                onClick={onReflectHandle}
                aria-haspopup="true"
              >
              {count > 0 && (
                <Badge 
                  badgeContent={count}
                  color="primary"
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  sx={{
                    '& .MuiBadge-badge': {
                      transform: 'translate(12px, -10px)',
                    }
                  }}
                >
                  <ReflectIcon 
                      // size="medium" 
                      sx={{
                        fontSize: 18, 
                          // color: theme.palette.primary.main,
                  }}/> 
                </Badge>
              )}
              {(!count || count === 0) && (
                <ReflectIcon 
                    // size="medium" 
                    sx={{
                      fontSize: 18, 
                        // color: theme.palette.primary.main,
                }}/> 
              )}
             </IconButton>
          </Tooltip>
        ) : (   
          <Tooltip title="Add personal reflection about this user">
            <IconButton 
              onClick={onReflectHandle}
              aria-haspopup="true"
            >
              <ReflectionIcon 
                sx={{
                  fontSize: 18, 
                  // color: theme.palette.primary.main,
              }}/> 
            </IconButton>
          </Tooltip>
        )}
    </>
  )
};

export default ReflectButton;